import { TextBoxFilterBaseCustomElement } from 'General/Resources/Elements/TextBoxFilter/TextBoxFilterBase';
import { customElement } from 'aurelia-framework';

@customElement('text-box-filter')
export class TextBoxFilterCustomElement extends TextBoxFilterBaseCustomElement {}